/**
 * moq-handler.js
 *
 * This script enforces Minimum Order Quantity (MOQ) logic on Shopify product pages.
 * It does the following:
 * - Reads per-variant MOQ values from a Liquid-injected `window.variantMoqMap`
 * - Displays a MOQ message if the current variant has a minimum greater than 1
 * - Sets the quantity input to match the MOQ (or 1 if none is set)
 * - Enables or disables the Add to Cart button based on whether MOQ is met
 * - Works on initial page load, variant changes, and quantity changes
 *
 * - Requires window.variantMoqMap code change in main-product--default.liquid.
 *
 * - Requires the following CSS in the Theme's custom css:
        button.moq-disabled {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
 *
 * - Added 2025-04-24 - MP
 */

(function () {
  let currentMoq = 1;
  let currentVariantId = null;

  // Finds the active quantity input field using data attribute from theme
  function getQuantityInput() {
    return document.querySelector('[data-quantity-input]');
  }

  // Finds the Add to Cart button within the product form
  function getAddToCartButton() {
    return document.querySelector('form[data-product-form] button[type="submit"]');
  }

  // Disables the add to cart button while the page is loading.
  const addToCartBtn = getAddToCartButton();
  if (addToCartBtn) {
    addToCartBtn.setAttribute("disabled", "disabled");
    addToCartBtn.classList.add("moq-disabled");
  }

  // Updates or hides the MOQ message depending on the current variant
  function updateMOQMessage() {
    const quantityLabel = document.querySelector('label[for^="Quantity-Input"]');
    if (!quantityLabel) return;

    quantityLabel.innerHTML = "Quantity";

    if (currentMoq > 1) {
      quantityLabel.innerHTML = `Quantity <span style="color: #d00; font-weight: bold;">(Minimum Order Quantity: ${currentMoq})</span>`;
    }
  }
  
  // Enables or disables the Add to Cart button based on MOQ validation
  function updateButtonState() {
    const qty = parseInt(getQuantityInput()?.value || "1", 10);
    const addToCartBtn = getAddToCartButton();
    const isValid = qty >= currentMoq;

    if (addToCartBtn) {
      if (isValid) {
        addToCartBtn.removeAttribute("disabled");
        addToCartBtn.classList.remove("moq-disabled");
      } else {
        addToCartBtn.setAttribute("disabled", "disabled");
        addToCartBtn.classList.add("moq-disabled");
      }
    }
  }




// When a variant is selected, update MOQ, quantity input, and button state
document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail?.variant;
  if (!variant) return;

  currentVariantId = variant.id;
  currentMoq       = window.variantMoqMap?.[variant.id] || 1;

  updateMOQMessage();

  const quantityInput = getQuantityInput();
  if (quantityInput) {
    // 1) Set the visible field’s min
    quantityInput.min = currentMoq;

    // 2) If visible value ≠ MOQ, force it to MOQ and fire change events
    const currentQty = parseInt(quantityInput.value || "1", 10);
    if (currentQty !== currentMoq) {
      quantityInput.value = currentMoq;
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      quantityInput.dispatchEvent(
        new CustomEvent("product:quantity-update", { bubbles: true })
      );
    }

    // 3) ALSO update the hidden <input name="quantity"> inside the product form
    const hiddenQuantityInput = document.querySelector(
      'form[data-product-form] input[name="quantity"]'
    );
    if (hiddenQuantityInput) {
      hiddenQuantityInput.value = currentMoq;
      hiddenQuantityInput.min   = currentMoq;
    }
  }

  // 4) Finally, re-run Add to Cart button state
  updateButtonState();
});


  
  // When user adjusts quantity manually, recheck button state
  document.addEventListener("product:quantity-update", function () {
    updateButtonState();
  });
  
  
// On initial load, wait for theme to render, then apply logic
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const variantSelect = document.querySelector('select[data-variant-select]');
    const initialId = parseInt(variantSelect?.value);
    const quantityInput = getQuantityInput();
    const addToCartBtn = getAddToCartButton();
    if (!initialId || !quantityInput || !addToCartBtn) return;

    currentVariantId = initialId;
    currentMoq = window.variantMoqMap?.[initialId] || 1;

    updateMOQMessage();

    quantityInput.min = currentMoq;
    const currentQty = parseInt(quantityInput.value || "1", 10);
    if (currentQty !== currentMoq) {
      quantityInput.value = currentMoq;
      // Update hidden quantity input in the form
      const hiddenQuantityInput = document.querySelector('form[data-product-form] input[name="quantity"]');
      if (hiddenQuantityInput) {
        hiddenQuantityInput.value = currentMoq;
        // Ensure min attribute is updated to prevent form validation issues
        hiddenQuantityInput.min = currentMoq;
      }
      quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
      quantityInput.dispatchEvent(new CustomEvent("product:quantity-update", { bubbles: true }));
    }

    updateButtonState();
  }, 200);  // Wait 200ms to give time for everything else to load first.
});

})();